module.exports = __webpack_public_path__ + "img/forsta.9b036d11.png";